import { ImageLibraryServiceModule } from './imageLibrary.service';

export const ImageLibraryLaunchModule = angular
    .module('app.components.imageLibrary.imageLibraryLaunch', [
        ImageLibraryServiceModule
    ]).directive('imageLibraryLaunch', (imageLibraryService) => {
        return {
            restrict: 'A',
            scope: {
                imageLibraryOnClearImage: '<',
                imageLibraryOnImagesSelected: '&',
                imageLibraryContext: '=',
                imageLibraryAssociationTags: '=',
                imageLibraryMultiSelect: '=',
                imageLibraryOverrideFunc: '&?',
                hasLibraryOverride: '<?'
            },
            link: (scope, element) => {
                element.on('click', (event) => {
                    if (scope.hasLibraryOverride) {
                        scope.imageLibraryOverrideFunc()();
                        return;
                    }
                    imageLibraryService.open({
                        event,
                        multiSelect: scope.imageLibraryMultiSelect,
                        context: scope.imageLibraryContext,
                        associationTags: scope.imageLibraryAssociationTags,
                        clearImage: scope.imageLibraryOnClearImage
                    }).then((images) => {
                        scope.imageLibraryOnImagesSelected({ selectedImages: images });
                    });
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/imageLibrary/launchImageLibrary.directive.js